import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { productService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parsePriceTypes } from './utils'
import { selectors } from './selectors'
import { TPriceTypesState, TRootState } from '../../types'
import { priceTypesAdapter } from './adapter'

const name = 'priceTypes'

const initialState: TPriceTypesState = {
    ...priceTypesAdapter.getInitialState(),
    isFetching: false
}

interface TFetchArg {
    isForce?: boolean
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async () => {
        return parsePriceTypes(await productService.fetchPriceTypes())
    },
    {
        serializeError: parseHttpError,
        condition: ({ isForce = false }: TFetchArg = {}, { getState }): boolean  =>
            !selectors.fetchStatus(getState() as TRootState).isFetching || isForce
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                priceTypesAdapter.setAll(state, action.payload)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const priceTypes = {
    name: slice.name,
    actions: {
        fetch,
    },
    reducer: slice.reducer,
    selectors,
}